import type { ReactNode } from "react";

import * as React from "react";

import PageHeader from "@replo/design-system/blocks/page-header/PageHeader";
import { useExperimentDetails } from "@v1/features/experiments/tabs/hooks/useExperimentDetails";
import AnnouncementMessage from "@v2/features/announcements/AnnouncementMessage";

import { TabMenu } from "./tabs/TabMenu";

type ExperimentsLayoutProps = React.PropsWithChildren<{
  headerTitle?: ReactNode;
  headerActions?: ReactNode;
  showStatus?: boolean;
  onBackClick?: () => void;
}>;

export const ExperimentsLayout = ({
  headerTitle,
  children,
  headerActions,
  onBackClick,
}: ExperimentsLayoutProps) => {
  const { experiment } = useExperimentDetails();

  return (
    <div className="relative flex w-full flex-col gap-4 overflow-hidden px-3 sm:px-6">
      <div className="flex flex-col gap-2.5">
        <PageHeader
          title={headerTitle}
          onBackClick={onBackClick}
          actions={headerActions}
          showDivider={false}
        >
          {!experiment && <AnnouncementMessage tags={["A/B Testing"]} />}
        </PageHeader>
        {experiment && <TabMenu />}
      </div>
      {children}
    </div>
  );
};
